/**
 * CSRF Token Setup
 * Injects CSRF meta tags and updates form authenticity tokens
 * 
 * Note: CSRF tokens come from globals.json via primeval.js
 */

/**
 * Initialize CSRF protection
 * - Creates meta tags for Rails UJS compatibility
 * - Updates all form authenticity_token inputs
 */
export function initCsrf() {
  try {
    if (!window.pageCsrf?.param || !window.pageCsrf?.token) {
      console.debug('CSRF tokens not yet available');
      return;
    }

    const headEl = document.head;

    // Create csrf-param meta tag if not exists
    if (!document.querySelector('meta[name="csrf-param"]')) {
      const metaCsrfParam = document.createElement('meta');
      metaCsrfParam.setAttribute('name', 'csrf-param');
      metaCsrfParam.content = window.pageCsrf.param;
      headEl.appendChild(metaCsrfParam);
    }

    // Create csrf-token meta tag if not exists
    if (!document.querySelector('meta[name="csrf-token"]')) {
      const metaCsrfToken = document.createElement('meta');
      metaCsrfToken.setAttribute('name', 'csrf-token');
      metaCsrfToken.content = window.pageCsrf.token;
      headEl.appendChild(metaCsrfToken);
    }

    // Update all form authenticity tokens
    updateFormTokens();
  } catch (e) {
    window.ErrorReporter?.critical('Error handling CSRF', e);
  }
}

/**
 * Update all authenticity_token inputs with current CSRF token
 */
export function updateFormTokens() {
  if (!window.pageCsrf?.token) return;
  
  document.querySelectorAll('input[name=authenticity_token]').forEach(input => {
    input.value = window.pageCsrf.token;
  });
}

